import React from "react";
import { Typography, Steps, Alert } from "antd";
import { CarOutlined, PlayCircleOutlined, TrophyOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";
import "./dontDrinkAndDrive.css";

const { Text } = Typography;

const stepIcons = [<CarOutlined key="car" />, <PlayCircleOutlined key="play" />, <TrophyOutlined key="trophy" />];

const DontDrinkAndDrive: React.FC = () => {
    const { t } = useTranslation();
    const steps = t("games.details.dontDrinkAndDrive.steps", {
        returnObjects: true,
    }) as Array<{
        title: string;
        description: string;
        ruleTitle?: string;
        ruleHint?: string;
    }>;

    return (
        <GamePage game="dontDrinkAndDrive" tagColor="gold" instructionIcons={stepIcons}>
            <Steps
                direction="vertical"
                className="dont-drink-and-drive-steps"
                items={steps.map((step, index) => ({
                    title: <Text strong>{step.title}</Text>,
                    icon: stepIcons[index],
                    description: (
                        <Text>
                            {step.description}
                            {step.ruleTitle && (
                                <>
                                    <br />
                                    <br />
                                    <Text strong>{step.ruleTitle}</Text>{" "}
                                    <Text>{t("games.details.dontDrinkAndDrive.ruleInstruction")}</Text>{" "}
                                    <Text type="secondary">{step.ruleHint}</Text>
                                </>
                            )}
                        </Text>
                    ),
                }))}
            />
            <Alert className="dont-drink-and-drive-warning" message={t("games.details.dontDrinkAndDrive.warning")} type="info" showIcon />
        </GamePage>
    );
};

export default DontDrinkAndDrive;
